var env = import.meta.env.VITE_STAGE || 'local';
var configs = (window.Configs || {})[env] || {};

export const API_DEV = configs.API || '/';
